import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFraseSeleccionAplicacionPlantelService,
  getFraseSeleccionAplicacionPlantelByIdService,
  getFrasesSeleccionAplicacionPlantelService,
  toggleFraseSeleccionAplicacionPlantelActiveService,
  updateFraseSeleccionAplicacionPlantelService,
} from "../../../services/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.service";

export const getFrasesSeleccionAplicacionPlantelThunk = createAsyncThunk(
  "frasesSeleccionAplicacionPlantel/getAll",
  async ({ plantelId, page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getFrasesSeleccionAplicacionPlantelService(
        plantelId,
        page,
        search,
      );
    } catch (error) {
      if (error.response?.status === 404)
        return rejectWithValue("Página no válida");
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener frases",
      );
    }
  },
);

export const getFraseSeleccionAplicacionPlantelByIdThunk = createAsyncThunk(
  "frasesSeleccionAplicacionPlantel/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getFraseSeleccionAplicacionPlantelByIdService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener frase",
      );
    }
  },
);

export const updateFraseSeleccionAplicacionPlantelThunk = createAsyncThunk(
  "frasesSeleccionAplicacionPlantel/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateFraseSeleccionAplicacionPlantelService(id, payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al actualizar frase",
      );
    }
  },
);

export const createFraseSeleccionAplicacionPlantelThunk = createAsyncThunk(
  "frasesSeleccionAplicacionPlantel/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createFraseSeleccionAplicacionPlantelService(payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al crear frase",
      );
    }
  },
);

export const toggleFraseSeleccionAplicacionPlantelActiveThunk =
  createAsyncThunk(
    "frasesSeleccionAplicacionPlantel/toggleActive",
    async (id, { rejectWithValue }) => {
      try {
        return await toggleFraseSeleccionAplicacionPlantelActiveService(id);
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.detail ||
            error.response?.data?.message ||
            "Error al cambiar estado",
        );
      }
    },
  );
